{
  "EMOJI": {
    "PLACEHOLDER": "搜索表情符号",
    "NOT_FOUND": "没有适合你的搜索结果",
    "REMOVE": "删除"
  }
}
